import { NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica, authLink } from 'app/utils/boolean-input';

@Component({
  selector: 'app-footer-menu',
  standalone: true,
  imports: [MatIconModule, NgIf, NgFor, UpperCasePipe],
  templateUrl: './footer-menu.component.html',
})
export class FooterMenuComponent{


    @Input() data:any;

    SVG_ICONS=["heroicons_outline:building-library","heroicons_outline:calendar","heroicons_outline:cog-8-tooth",""]

    checkModificax(){
        return checkModifica()
    }


    authLink(url: string){
        return authLink(url)
    }



}
